import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ContaInserirComponent } from './conta-inserir.component'; 


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: ContaInserirComponent }
    ])],
    exports: [RouterModule]
})
export class ContaInserirRoutingModule { }
